import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchRemoteActions, addRemoteAction } from '../actions/remoteactions'
import { renderInputField, renderSelectField } from '../utils/forms'

class RemoteActionAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this)
  }

  submit(props) {

    if (!props.arguments || props.arguments === '') {
      throw new SubmissionError({
        arguments: 'No envíes formularios vacíos por favor!'
      });
    }

    props.machine = this.props.machine._id
    props.executor = this.props.fullname

    return this.props.addRemoteAction(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        this.props.fetchRemoteActions(this.props.machine.Serial)

        this.props.reset()

        return response
      })
  }

  quickAction(code) {
    this.props.dispatch(change('RemoteActionAddForm', 'code', code))
    this.props.dispatch(change('RemoteActionAddForm', 'arguments', 'vacway'))
  }

  render() {
    const { error, pristine, submitting, handleSubmit, machine, fetchRemoteActions, reset } = this.props

    const operativeButtons = [
      { code: 'REBOOT',      label: 'Reiniciar',    icon: 'fa-power-off',      color: '#1d4ed8' },
      { code: 'DOOR_OPEN',   label: 'Abrir Kiosco', icon: 'fa-door-open',      color: '#1d4ed8' },
      { code: 'GET_ESP32',   label: 'Estado ESP32',  icon: 'fa-bluetooth',      color: '#1d4ed8' },
      { code: 'GET_MAC',     label: 'Solicitar MAC', icon: 'fa-globe',          color: '#1d4ed8' },
      { code: 'Q6000_DEVICE',label: 'Info Q6000',    icon: 'fa-mobile-screen',  color: '#1d4ed8' },
    ]

    const criticalButtons = [
      { code: 'UNRENT_ALL',      label: 'Desalquilar Todas', icon: 'fa-lock-open',  color: '#dc2626' },
      { code: 'FORCEDNIGHTSCAN', label: 'Forced Nightscan',  icon: 'fa-wifi',       color: '#dc2626' },
      { code: 'OPEN_ALL',        label: 'Abrir Todas',       icon: 'fa-door-open',  color: '#dc2626' },
    ]

    return (
      <div className="od-remote-inner">
        {/* Quick action buttons */}
        <div className="od-remote-quick">
          <div className="od-remote-section-title">
            <i className="fas fa-bolt"></i> Acciones rápidas
          </div>
          <div className="od-remote-btn-group-label operative" style={{ marginBottom: '8px' }}>
              <i className="fas fa-cogs"></i> Operativas
            </div>
          <div className="od-remote-btn-row" style={{ marginBottom: '16px' }}>
            {operativeButtons.map(btn => (
              <button
                key={btn.code}
                type="button"
                className="od-remote-btn"
                style={{ '--btn-color': btn.color }}
                onClick={() => this.quickAction(btn.code)}
              >
                <span className="od-remote-btn-icon">
                  <i className={`fas ${btn.icon}`}></i>
                </span>
                <span className="od-remote-btn-label">{btn.label}</span>
              </button>
            ))}
          </div>
          <div className="od-remote-btn-group-label critical" style={{ marginBottom: '8px' }}>
            <i className="fas fa-exclamation-triangle"></i> Críticas
          </div>
          <div className="od-remote-btn-row">
            {criticalButtons.map(btn => (
              <button
                key={btn.code}
                type="button"
                className="od-remote-btn"
                style={{ '--btn-color': btn.color }}
                onClick={() => this.quickAction(btn.code)}
              >
                <span className="od-remote-btn-icon">
                  <i className={`fas ${btn.icon}`}></i>
                </span>
                <span className="od-remote-btn-label">{btn.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Advanced form */}
        <div className="od-remote-form-wrap">
          <div className="od-remote-section-title">
            <i className="fas fa-terminal"></i> Formulario avanzado
          </div>
          <div className="od-remote-alert">
            <i className="fas fa-exclamation-triangle"></i>
            Selecciona acciones directamente del formulario solo si sabes lo que haces, si no utiliza los botones predefinidos.
          </div>
          <form onSubmit={handleSubmit(this.submit)} className="od-remote-form">
            <div className="od-remote-fields-row">
              <Field name="code" component={renderSelectField}>
                <option value="">Selecciona una acción...</option>
                <optgroup label="Operativas">
                  <option value="REBOOT">Reiniciar</option>
                  <option value="DOOR_OPEN">Abrir Kiosco</option>
                  <option value="GET_ESP32">Estado ESP32</option>
                  <option value="GET_MAC">Solicitar MAC</option>
                  <option value="Q6000_DEVICE">Info Q6000</option>
                </optgroup>
                <optgroup label="Críticas">
                  <option value="UNRENT_ALL">Desalquilar Todas</option>
                  <option value="FORCEDNIGHTSCAN">Forced Nightscan</option>
                  <option value="OPEN_ALL">Abrir Todas</option>
                </optgroup>
                <optgroup label="Avanzadas">
                  <option value="COMMONS_UPDATE">Actualizar Audios/Videos</option>
                  <option value="SINGLE_COMMAND">Comando de terminal</option>
                </optgroup>
              </Field>
              <Field name="arguments"
                type="text"
                component={renderInputField}
                placeholder="Argumentos" />
            </div>
            <div className="od-remote-form-actions">
              <button className="od-remote-submit" type="submit" disabled={pristine || submitting}>
                <i className="fas fa-bolt"></i> Ejecutar
              </button>
              <button className="od-remote-refresh" type="button" onClick={() => fetchRemoteActions(machine.Serial)}>
                <i className="fas fa-sync"></i> Actualizar
              </button>
            </div>
            {error && <div className="od-remote-error">{error}</div>}
          </form>
        </div>
      </div>
    )
  }
}

RemoteActionAddForm = reduxForm({
  form: 'RemoteActionAddForm',
})(RemoteActionAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  addRemoteAction: bindActionCreators(addRemoteAction, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionAddForm)

